import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Calendar, Clock } from "lucide-react";
import { openGoogleCalendar } from "@/lib/utils";

export const OnlineConsultation: React.FC = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-[#f4fbf7]">
      <div className="container mx-auto px-6">
        <Card className="max-w-4xl mx-auto shadow-xl">
          <CardContent className="p-8 text-center">
            <div className="w-16 h-16 bg-gradient-to-br from-brand-primary to-brand-primary rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <span className="text-white text-2xl">💻</span>
            </div>
            <h2 className="text-3xl font-bold font-primary text-gray-800 mb-4">
              Consulta Online
            </h2>
            <p className="text-xl font-secondary text-gray-600 mb-8">
              Não pode se deslocar? Oferecemos consultas online com a mesma qualidade do atendimento presencial
            </p>
            
            <div className="grid md:grid-cols-3 gap-6 mb-8">
              <div className="bg-white rounded-lg p-6 shadow-sm">
                <div className="w-12 h-12 bg-brand-primary/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <Clock className="w-6 h-6 text-brand-primary" />
                </div>
                <h3 className="font-semibold font-accent mb-2">Horários Flexíveis</h3>
                <p className="font-text text-gray-600 text-sm">Agendamento conforme sua disponibilidade</p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-sm">
                <div className="w-12 h-12 bg-brand-primary/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <span className="text-brand-primary text-xl">🏠</span>
                </div>
                <h3 className="font-semibold font-accent mb-2">Conforto de Casa</h3>
                <p className="font-text text-gray-600 text-sm">Atendimento no conforto do seu lar</p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-sm">
                <div className="w-12 h-12 bg-brand-primary/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <span className="text-brand-primary text-xl">⚡</span>
                </div>
                <h3 className="font-semibold font-accent mb-2">Mesma Qualidade</h3>
                <p className="font-text text-gray-600 text-sm">Atendimento completo e personalizado</p>
              </div>
            </div>

            <Button 
              size="lg" 
              className="bg-brand-primary hover:bg-brand-primary/90 font-accent shadow-lg transform hover:scale-105 transition-all duration-300"
              onClick={openGoogleCalendar}
            >
              <Calendar className="w-5 h-5 mr-2" />
              Agendar Consulta Online
            </Button>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
